module.exports = __webpack_public_path__ + "img/viajando.4115c8b5.jpg";